// extracted by css-extract-rspack-plugin
export default {"triggerButton":"AyJHI","triggerButtonLabel":"jUEuR","chevronIcon":"KEf4W","chevronDown":"AtfP5","selectListItem":"qm3Z3","moreButton":"ILigB"};